<div class="error-wrapper">
    <div class="animatedbox animatedbox-one"></div>
    <div class="animatedbox animatedbox-two"></div>
    <div class="animatedbox animatedbox-three"></div>
    <div class="blurr"></div>
    <div class="content">
        <p class="eon_optimum_logo">
            <a href="https://www.eon.com/"><span></span></a>
        </p>
        <div class="apperror-main">
            <h1>User does not have access to this application, please discuss with your platform administrator.</h1>

            <div class="support"></div>
        </div>
        <button class="eon-button bg-eon-white logout" (click)="logout()">
            Return to Login
        </button>
    </div>
    <div class="apperror-footer">
        <p>© {{ currentYear }} E.ON UK</p>
    </div>
</div>
